// extracted by css-extract-rspack-plugin
export default {"formIntroduction":"Introduction_formIntroduction__E-jG2"};